import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

/**
 * Angular does not reliably bind MediaStream to <video>.srcObject via template.
 * This directive sets srcObject imperatively whenever the stream changes.
 */
@Directive({
  selector: '[ssSrcObject]',
  standalone: false,
})
export class SrcObjectDirective implements OnChanges {
  @Input('ssSrcObject') stream: MediaStream | null | undefined;

  constructor(private el: ElementRef<HTMLVideoElement>) { }

  ngOnChanges(): void {
    const video = this.el.nativeElement;
    try {
      (video as any).srcObject = this.stream || null;
    } catch {
      // Fallback for older browsers: do nothing.
    }
  }
}

